module.exports = new Promise(async (resolve, reject) => {
  /* ─────────── 1. look up the URL ─────────── */
  const urlGetter = window.__mf_getUrl
  const remoteUrl = urlGetter && urlGetter('user_actions')

  if (!remoteUrl) {
    reject(new Error('No URL configured for remote "user_actions"'))
    return
  }
  if (!/^(https?):\/\//.test(remoteUrl)) {
    reject(new Error('Invalid URL for remote "user_actions": ' + remoteUrl))
    return
  }

  /* ─────────── 2. quick HEAD pre-flight (3s) ─────────── */
  const fetchWithTimeout = (url, timeoutMs = 3000) =>
    new Promise((res, rej) => {
      const t = setTimeout(() => rej(new Error('Timeout while checking ' + url)), timeoutMs)
      fetch(url, { method: 'HEAD' })
        .then(r => { clearTimeout(t); res(r) })
        .catch(e => { clearTimeout(t); rej(e) })
    })

  try {
    const head = await fetchWithTimeout(remoteUrl)
    if (!head.ok) {
      reject(new Error('Remote "user_actions" responded with HTTP ' + head.status))
      return
    }
  } catch (err) {
    reject(new Error('Failed to fetch remote "user_actions": ' + err.message))
    return
  }

  /* ─────────── 3· already loaded? ─────────── */
  if (window['user_actions']) {
    resolve(window['user_actions'])
    return
  }

  /* ─────────── 4· inject <script> and init ─────────── */
  const script = document.createElement('script')
  script.src = remoteUrl
  script.type = 'text/javascript'
  script.async = true

  script.onload  = () => resolve(window['user_actions'])

  script.onerror = () => {
    script.remove()
    reject(new Error('Failed to load remote "user_actions" from ' + remoteUrl))
  }

  document.head.appendChild(script)
});